import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { LetterOnBoard } from '@schoolbelle/api/letter-to-board';
import { BadgeService } from '@schoolbelle/api/badge';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-letter-new-badge',
  templateUrl: './letter-new-badge.component.html',
  styleUrls: ['./letter-new-badge.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class LetterNewBadgeComponent implements OnInit {
  @Input() item:LetterOnBoard;  
  constructor(
    private badge:BadgeService,
    private cdRef:ChangeDetectorRef,
  ) {
  }

  subscription = new Subscription();
  ngOnInit() {
    this.subscription.add(
      this.badge.onChange.subscribe(()=>this.cdRef.detectChanges())
    );
  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }
  get isNew ():boolean {
    const ltg_id:number = this.item && this.item.ltg_id;
    return (
      ltg_id 
      && (
        this.badge.find({'action':'letter_to_group.insert', 'new.ltg_id' : ltg_id, 'read':0})
        || this.badge.find({'action':'letter_to_group.approval', 'new.ltg_id' : ltg_id, 'read':0})
        || this.badge.find({'action':'letter_to_group.reply', 'new.ltg_id' : ltg_id, 'read':0})
      )
    )? true : false;
  }

}
